module.exports = __webpack_public_path__ + "img/studyexercise.f1eff134.svg";